'use client'

import {Box, Loading} from '@viptech/react-components'
import {useEffect, useState} from 'react'
import {buildNewPortalAuthUrl, type NewPortalAuthPath} from 'src/lib/portal-migration/build-new-portal-auth-url'

type Props = {
  path: NewPortalAuthPath
  fallback?: React.ReactNode
}

export function RedirectToNewPortalAuth({path, fallback = null}: Props) {
  const [showFallback, setShowFallback] = useState(false)

  useEffect(() => {
    const target = buildNewPortalAuthUrl(path)
    if (target) {
      window.location.replace(target)
      return
    }
    setShowFallback(true)
  }, [path])

  if (showFallback) return <>{fallback}</>

  return (
    <Box height='100vh' display='flex' justifyContent='center' align='center'>
      <Loading size='30px' />
    </Box>
  )
}
